var _StringBuilder_strings, _StringBuilder_lastValue, _StringBuilder_invalidateLastValue;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { empty, newLine } from '../Strings/_consts';
/**
 * Class for building strings that will only concatenate them upon calling toString().
 */
export default class StringBuilder {
    /**
     * Create a new StringBuilder.
     * @param value
     */
    constructor(...value) {
        _StringBuilder_strings.set(this, void 0);
        _StringBuilder_lastValue.set(this, void 0);
        _StringBuilder_invalidateLastValue.set(this, void 0);
        __classPrivateFieldSet(this, _StringBuilder_strings, [...value], "f");
        __classPrivateFieldSet(this, _StringBuilder_invalidateLastValue, true, "f");
    }
    /**
     * Append the value to the builder
     * @param value
     */
    append(value) {
        __classPrivateFieldGet(this, _StringBuilder_strings, "f").push(value);
        __classPrivateFieldSet(this, _StringBuilder_invalidateLastValue, true, "f");
    }
    /**
     * Appends the value to the builder with a new line afterwards.
     * @param value
     */
    appendLine(value) {
        __classPrivateFieldGet(this, _StringBuilder_strings, "f").push(...[value, newLine]);
        __classPrivateFieldSet(this, _StringBuilder_invalidateLastValue, true, "f");
    }
    /**
     * Clears all values from the StringBuilder.
     */
    clear() {
        __classPrivateFieldGet(this, _StringBuilder_strings, "f").length = 0;
        __classPrivateFieldSet(this, _StringBuilder_invalidateLastValue, true, "f");
    }
    /**
     * Returns a string representation of the StringBuilder.
     */
    toString() {
        if (__classPrivateFieldGet(this, _StringBuilder_invalidateLastValue, "f")) {
            __classPrivateFieldSet(this, _StringBuilder_invalidateLastValue, false, "f");
            return __classPrivateFieldSet(this, _StringBuilder_lastValue, __classPrivateFieldGet(this, _StringBuilder_strings, "f").join(empty), "f");
        }
        else {
            return __classPrivateFieldGet(this, _StringBuilder_lastValue, "f") || empty;
        }
    }
}
_StringBuilder_strings = new WeakMap(), _StringBuilder_lastValue = new WeakMap(), _StringBuilder_invalidateLastValue = new WeakMap();
